export default __webpack_public_path__ + "static/media/TopicTips_Images.e997d49a.svg";